<template>
    <crud-layout title="Planes" subtitle="Gestión de planes de permisos" :add-button="true" @add="creating = true">
        <template v-slot:list>
            <plan-list
                @create="creating = true"
                @update="openUpdate"
                @delete="openDelete"
            />
        </template>

        <plan-create
            v-if="creating"
            :open="creating"
            @planCreated="onPlanCreated"
            @close="creating = false"
        />

        <plan-update
            v-if="!!planToUpdate"
            :open="!!planToUpdate"
            :plan="planToUpdate"
            @planUpdated="onPlanUpdated"
            @close="planToUpdate = null"
        />

        <plan-delete
            v-if="!!planToDelete"
            :open="!!planToDelete"
            :plan="planToDelete"
            @planDeleted="onPlanDeleted"
            @close="planToDelete = null"
        />

        <snackbar v-model="flash" />
    </crud-layout>
</template>

<script>
import PlanList from '../PlanList'
import PlanCreate from '../PlanCreate'
import PlanUpdate from '../PlanUpdate'
import PlanDelete from '../PlanDelete'
import { CrudLayout, Snackbar } from '@dracul/common-frontend'

export default {
    name: 'PlanCrud',
    components: { CrudLayout, Snackbar, PlanList, PlanCreate, PlanUpdate, PlanDelete },
    data() {
        return {
            creating: false,
            planToUpdate: null,
            planToDelete: null,
            flash: null
        }
    },
    methods: {
        openUpdate(plan) {
            this.planToUpdate = plan
        },
        openDelete(plan) {
            this.planToDelete = plan
        },
        onPlanCreated() {
            this.flash = 'Plan creado correctamente'
            this.creating = false
        },
        onPlanUpdated() {
            this.flash = 'Plan actualizado correctamente'
            this.planToUpdate = null
        },
        onPlanDeleted() {
            this.flash = 'Plan eliminado correctamente'
            this.planToDelete = null
        }
    }
}
</script>
